import config from "../../config/config";

export const validateInput = (values: Record<string, string>): Record<string, string> => {
  const errors: Record<string, string> = {};

  Object.entries(values).forEach(([key, value]) => {
    switch (key) {
      case "official_email_address":
      case "email_address": {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // General email validation
        let allowedDomainRegex: RegExp;
        // Allow `7edge.com` in dev/qa, and `zood-pay.com` for all environments
        if (config.stage === 'dev' || config.stage === 'qa') {
          allowedDomainRegex = /@(7edge\.com|zood-pay\.com)$/;
        } else {
          allowedDomainRegex = /@zood-pay\.com$/; // External stakeholders only allow `zood-pay.com`
        }

        if (!emailRegex.test(value) || !allowedDomainRegex.test(value)) {
          errors[key] = "Invalid email address";
        }
        break;
      }

      case "password": {
        const passwordCriteria = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^\w\s]).{6,16}$/;
        if (!passwordCriteria.test(value)) {
          errors[key] = "Invalid password";
        }
        break;
      }

      default:
        break;
    }
  });

  return errors;
};